import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../../components/shared/Card';
import { Select } from '../../../../components/shared/inputs';
import { MENU_TYPE } from '../enums';

interface TemplateSectionProps {
  menuType: string;
  onMenuTypeChange: (value: string) => void;
}

export const TemplateSection: React.FC<TemplateSectionProps> = ({ menuType, onMenuTypeChange }) => {
  const { t } = useTranslation();

  return (
    <Card className="border border-gray-200 rounded-lg p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-1">{t('PrintDialog.MenuTemplate')}</h2>
      <p className="text-sm text-gray-500 mb-4">{t('PrintDialog.TemplateSectionHelper')}</p>
      <Select
        label={t('PrintDialog.Template')}
        value={menuType}
        onChange={(value) => onMenuTypeChange(String(value))}
        options={[
          { value: MENU_TYPE.DEFAULT, label: t('PrintDialog.DefaultMenuType') },
          { value: MENU_TYPE.CLASSIC, label: t('PrintDialog.ClassicMenuType') },
          { value: MENU_TYPE.VERTICAL, label: t('PrintDialog.VerticalMenuType') },
          { value: MENU_TYPE.NEW_YORK, label: t('PrintDialog.NewYorkMenuType') }
        ]}
      />
    </Card>
  );
};
